import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-participant-planning-card',
  templateUrl: './participant-planning-card.component.html',
  styleUrls: ['./participant-planning-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantPlanningCardComponent implements OnInit {
  deleteAlert: string = 'Voulez-vous supprimer cet événement ?';
  @Input() item: any = null;
  @Output() delete = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  onAction(event: string, item: any): void {
    switch (event) {
      case 'delete':
        this.delete.emit(item.id);
        break;

      default:
        break;
    }
  }
}
